var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliveryinfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48192",
    "data-name": "Group 48192",
    transform: "translate(-1214 -661)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19350",
    "data-name": "Rectangle 19350",
    width: 40,
    height: 40,
    transform: "translate(1214 661)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-calendar-4525303",
    transform: "translate(1119.267 602.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M122.381,70H120.3v1.39a.7.7,0,1,1-1.39,0V70h-3.476v1.39a.7.7,0,1,1-1.39,0V70h-3.476v1.39a.7.7,0,1,1-1.39,0V70h-2.086A2.085,2.085,0,0,0,105,72.086v2.781h19.467V72.086A2.085,2.085,0,0,0,122.381,70Z",
    transform: "translate(0 0)",
    fill: "#527e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M105,235.843a2.085,2.085,0,0,0,2.086,2.086h15.3a2.085,2.085,0,0,0,2.086-2.086V227.5H105Z",
    transform: "translate(0 -151.243)",
    fill: "#527e3c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryinfo);
export default __webpack_public_path__ + "static/media/delivery info.e4b345ca55100a815b96292accf50810.svg";
export { ForwardRef as ReactComponent };